import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

/**
 * Component to handle navigation from push notifications
 * This component listens for Service Worker messages and navigates accordingly
 */
const NotificationNavigationHandler = () => {
 const navigate = useNavigate();
 const location = useLocation();

 useEffect(() => {
 // Make navigate function available globally for Service Worker
 window.navigateFromNotification = (url, data = {}) => {
 console.log('[NAVIGATION] Navigating from notification:', { url, data });
 
 // Show toast notification about the navigation
 if (data.notificationType) {
 const typeNames = {
 'TASK': 'Nhiệm vụ',
 'VEHICLE_REQUEST': 'Yêu cầu xe',
 'WORK_REPORT': 'Báo cáo công việc',
 'FUEL_REQUEST': 'Yêu cầu nhiên liệu',
 'INCIDENT': 'Sự cố',
 'EVALUATION': 'Đánh giá',
 'ANNOUNCEMENT': 'Thông báo',
 'DOCUMENT': 'Tài liệu',
 'MEETING': 'Cuộc họp',
 'SCHEDULE': 'Lịch trình',
 'SUPPORT_TICKET': 'Hỗ trợ'
 };
 
 const typeName = typeNames[data.notificationType] || 'Thông báo';
 toast.info(`Đang mở ${typeName}...`, { autoClose: 2000 });
 }
 
 // Navigate to the URL
 navigate(url);
 
 // Handle specific actions
 if (data.action) {
 setTimeout(() => {
 handleNotificationAction(data.action, data);
 }, 500);
 }
 };

 // Handle URL parameters for direct notification navigation
 const handleUrlParams = () => {
 const urlParams = new URLSearchParams(location.search);
 const notificationId = urlParams.get('notificationId');
 const action = urlParams.get('action');
 
 if (notificationId) {
 console.log('[NAVIGATION] Found notification ID in URL:', notificationId);
 // Mark notification as read
 markNotificationAsRead(notificationId);
 
 // Remove notification parameters from URL
 const newParams = new URLSearchParams(location.search);
 newParams.delete('notificationId');
 if (action) newParams.delete('action');
 
 const newSearch = newParams.toString();
 const newUrl = location.pathname + (newSearch ? `?${newSearch}` : '');
 
 if (newUrl !== location.pathname + location.search) {
 navigate(newUrl, { replace: true });
 }
 }
 
 if (action) {
 handleNotificationAction(action, { notificationId });
 }
 };

 // Handle notification actions
 const handleNotificationAction = (action, data) => {
 console.log('[NAVIGATION] Handling action:', action, data);
 
 switch (action) {
 case 'approve':
 toast.info('Mở form phê duyệt...', { autoClose: 2000 });
 // You can trigger specific UI actions here
 break;
 case 'reject':
 toast.info('Mở form từ chối...', { autoClose: 2000 });
 break;
 case 'reply':
 toast.info('Mở form trả lời...', { autoClose: 2000 });
 break;
 default:
 console.log('[NAVIGATION] Unknown action:', action);
 }
 };

 // Mark notification as read
 const markNotificationAsRead = async (notificationId) => {
 try {
 console.log('[NAVIGATION] Marking notification as read:', notificationId);
 // You can implement this API call
 // await API.patch(`/notifications/${notificationId}/read`);
 } catch (error) {
 console.error('[NAVIGATION] Error marking notification as read:', error);
 }
 };

 // Check URL parameters on component mount
 handleUrlParams();

 // Cleanup function
 return () => {
 if (window.navigateFromNotification) {
 delete window.navigateFromNotification;
 }
 };
 }, [navigate, location]);

 // This component doesn't render anything
 return null;
};

export default NotificationNavigationHandler;
